{
  "helpMessage": "<p>如果您遇到问题，请致电 <a><strong>{{phone}}</strong></a>（然后按 <strong>选项 2</strong>）。</p>",
  "noCode": "没有收到验证码？",
  "remainingTime": "剩余 {{time}}",
  "sendCode": "发送新验证码",
  "text": "<p>我们已向您的手机号码发送了一个4位验证码：<strong><PhonePlaceholder /></strong></p>\n<p>该验证码在{{validityMinutes}}分钟内有效。</p>\n<p>请输入验证码以继续。</p>",
  "title": "请输入验证码"
}
